import { HostBackend } from '../../../Routes/HostBackend.js';
import { PostHeaders } from '../../../Components/Admin/Functions/FetchHeaders.js';

export const FormDelete = (props) => {
    const backend = HostBackend();
    const token = sessionStorage.getItem('token');
    const { entity, id } = props;

    const handleSubmitDelete = async (ev) => {
        ev.preventDefault();
        const id = ev.target.id.value;
        const inputs = document.getElementById(`form-delete-${id}`).elements;
        const params = new URLSearchParams();
        for (let input of inputs) {
            if (input.name && input.value && input.name !== undefined && input.value !== undefined) {
                params.append(input.name, input.value.toString());
            }
        }
        const formEntries = Object.fromEntries(params.entries());
        const resp = await fetch(`${backend}/admin/delete/${entity}`, PostHeaders(token, formEntries)).catch((e) => {
            console.log(e)
        });
        if (resp && resp.ok) {
            window.location = `/admin/entity/collection/${entity}`;
        } else {
            console.log(resp.err)
        }
    }
    return (
        <div className="button-delete">
            <form className="form" id={`form-delete-${id}`} onSubmit={handleSubmitDelete}>
                <input type="hidden" name="id" defaultValue={id} />
                <input type="submit" name="delete" value="Delete" className="button" title={id} />
            </form>
        </div>
    )
}